import { Component, Inject, Input, OnChanges, SimpleChanges, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppComponent } from "../app/app.component";
import { forEach } from "@angular/router/src/utils/collection";
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, window } from 'rxjs/operators';
declare var google: any;
@Component({
    selector: "owner",
    template: require('./owner.component.html'),
    styles: [require('./owner.component.css')]
})
export class OwnerComponent implements OnChanges, OnInit {

    report: CollisionReport;
    cityList: Array<String> = [];


    constructor(private appcomponent: AppComponent, private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        private router: Router, private formBuilder: FormBuilder) {
        this.report = appcomponent.getReport();
        if (this.report.CollisionReportUniqueId == null) {
            this.reportGetSync();
            this.router.navigate([this.router.url])
        }

        if (this.report.IsNew) {
            this.router.navigate(["home"]);
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (typeof changes['report'] !== "undefined") {
            // retrieve the report variable change info
            var change = changes['report'];
            // only perform the task if the value has been changed
            if (!change.isFirstChange()) {
                // execute the Http request and retrieve the result
                //DO SOmething
            }
        }
        else
            console.log("Undefined");
    }
    ngOnInit() {

    }
    ngAfterViewInit() {
        
    }

    onPhoneInput(): void {
        var phone = this.report.OwnerPhoneNumber.replace(/[^0-9]/g, "");
        var v = phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        this.report.OwnerPhoneNumber = v;
    }

    onOwnerOfTheVehicleChange(value: boolean): void {
        this.report.OwnerOfTheVehicle = value;
        if (!this.report.OwnerOfTheVehicle) {
           // this.setAutocomplete();
        }
    }
    
    onIsOwnerACompanyChange(value: boolean): void {
        this.report.IsOwnerACompany = value;
        
    }

    setAutocomplete(): void {
        var autoCompleteOptions = {
            types: [],
            componentRestrictions: { country: 'ca' }
        };
        var self = this;
        var autoCompleteElement = document.getElementById('OwnerAddress');
        alert(autoCompleteElement);
        var searchBox = new google.maps.places.Autocomplete(autoCompleteElement, autoCompleteOptions);
        
        //searchBox.bindTo('bounds', map);
        google.maps.event.addListener(searchBox, 'place_changed', function () {
            var place = searchBox.getPlace();
            if (!place.geometry) {
                //NOT SURE
            }
            else {
                var address: string = place.formatted_address;
                var array = address.split(",");
                self.report.OwnerAddress = array[0];
                var provPostal = array[2].trim();

                self.report.OwnerCity = array[1].trim() + ", " + provPostal.substring(0, provPostal.indexOf(' '));
                self.report.OwnerPostal = provPostal.substring(provPostal.indexOf(' ') + 1);
            }

        });

    }
    searchCity = (text$: Observable<string>) =>
        text$.pipe(
            debounceTime(200),
            distinctUntilChanged(),
            map(term => term.length < 2 ? []
                : this.searchCityData(term))
        );

    searchCityData(term: string): Array<String> {

        // states.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)
        var url = this.baseUrl + "api/report/City/" + term;
        var data: any;
        this.http
            .get(url)
            .subscribe(res => {
                data = res as string[];
                for (let i = 0; i < data.length; i++) {
                    this.cityList.push(data[i]);
                }
            }, error => console.log(error));
        if (data == null) {
            this.cityList.push("Not Found");
        }
        return Array.from(new Set(this.cityList)).filter(item =>
            item.toLowerCase().includes(term.toLowerCase()));
    }
    onBack(): void {
        if (this.report.EntityType=="PEDESTRIAN" || this.report.EntityType == "CYCLIST") {
            this.BackAndPost("prequalification");
        }
        else
            this.BackAndPost("prequalificationdriver");
    }
    private BackAndPost(page: string): void {

        this.report.CurrentPage = page;
      //  this.appcomponent.setReport(this.report);
        this.router.navigate([page]);
    }
    onSubmit(): void {
     //   alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.report));
        this.ValidateAndPost("otherdriver");
        //GO TO NEXT PAGE
    }

    private ValidateAndPost(page: string) {
        if (this.Isvalid()) {
            this.report.IsOwnerPageValid = true;
            // this.report.OtherDrivers.push(this.otherDriver);
            this.report.CurrentPage = page;
            this.appcomponent.setReport(this.report);
            //GO TO NEXT PAGE
            this.router.navigate([page]);
        }
        else {
            alert('Please select if you are the owner of the vehicle');
        }
    }
    private Isvalid(): boolean {
        if (this.report.OwnerOfTheVehicle == null) {

            return false;
        }
        else {
            if (!this.report.OwnerOfTheVehicle) {
                if (this.report.IsOwnerACompany == null) {
                    alert("Please select of Owner is a company or not.");
                    return false;
                }
            }

        }
        return true;
    }
    findChoicesCity(cityList: Array<String>) {
        return (searchText: any) => {
            var url = this.baseUrl + "api/report/City/" + searchText;
            var data: any;
            this.http
                .get(url)
                .subscribe(res => {
                    data = res as string[];
                    for (let i = 0; i < data.length; i++) {
                        cityList.push(data[i]);
                    }
                }, error => console.log(error));
            if (data == null) {
                cityList.push("Not Found");
            }
            return Array.from(new Set(cityList)).filter(item =>
                item.toLowerCase().includes(searchText.toLowerCase()));
        };
    }

    getChoiceLabelCity(choice: string) {
        return choice;
    }

    reportGetSync(): void {
        var url = this.baseUrl + "api/report";
        this.http
            .get(url)
            .toPromise().then(result => {
                var v = result as CollisionReport;
                this.report = v;
            });
    }



}